(function () {
  const money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  const wholeEuro = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });

  function cents(value) {
    return money.format((Number(value) || 0) / 100);
  }

  function parseData(root) {
    const node = root.querySelector('[data-metzger-selector-json]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (_error) {
      return null;
    }
  }

  function intervalPriority(plan) {
    const text = `${plan?.name || ''} ${plan?.description || ''}`.toLowerCase();
    if (text.includes('4') || text.includes('monat')) return 0;
    if (text.includes('8')) return 1;
    if (text.includes('12')) return 2;
    return 5;
  }

  function weightFromTitle(title = '') {
    const match = title.match(/(\d+(?:[,.]\d+)?)\s*kg/i);
    return match ? Number(match[1].replace(',', '.')) * 1000 : 0;
  }

  function savingsAmount(data, variant) {
    if (!variant) return 0;
    const grams = Number(variant.weight) || weightFromTitle(variant.title);
    if (!grams) return 0;
    return Number(grams >= 3300 ? data.savings?.largeAmount : data.savings?.smallAmount) || 0;
  }

  function monthlyPlanPrice(variant) {
    const plans = variant?.sellingPlans || [];
    const monthlyPlan = plans.find((plan) => {
      const text = `${plan.name || ''} ${plan.description || ''}`.toLowerCase();
      return text.includes('monatlich') || text.includes('alle 4') || text.includes('4 wochen');
    });
    return Number(monthlyPlan?.price) || Number(plans[0]?.price) || 0;
  }

  function comparisonPrice(data, variant) {
    const monthlyPrice = monthlyPlanPrice(variant);
    const savings = savingsAmount(data, variant) * 100;
    return monthlyPrice && savings ? monthlyPrice + savings : Number(variant?.price) || 0;
  }

  function deliveriesPerYear(plan) {
    const text = `${plan?.name || ''} ${plan?.description || ''}`.toLowerCase();
    if (text.includes('viertel') || text.includes('12')) return 4;
    if (text.includes('2 monat') || text.includes('8')) return 6;
    return 12;
  }

  function selectedPackage(root, data) {
    const packageCard = root.querySelector('[data-package-id].is-selected') || root.querySelector('[data-package-id]');
    return data.packages?.[packageCard?.dataset.packageId] || Object.values(data.packages || {})[0];
  }

  function selectedVariant(root, pkg) {
    const cards = Array.from(root.querySelectorAll('.r-metzger-selector__size'));
    const index = Math.max(0, cards.findIndex((card) => card.classList.contains('is-selected')));
    return pkg?.variants?.[index] || pkg?.variants?.[0];
  }

  function sortedPlans(variant) {
    return [...(variant?.sellingPlans || [])].sort((a, b) => intervalPriority(a) - intervalPriority(b));
  }

  function selectedPlan(root, plans) {
    const cards = Array.from(root.querySelectorAll('.r-metzger-selector__interval'));
    const index = Math.max(0, cards.findIndex((card) => card.classList.contains('is-selected')));
    return plans[index] || plans[0];
  }

  function fixSelector(root) {
    const data = parseData(root);
    if (!data) return;

    const pkg = selectedPackage(root, data);
    const variants = pkg?.variants || [];
    const sizeCards = Array.from(root.querySelectorAll('.r-metzger-selector__size'));
    sizeCards.forEach((card, index) => {
      const variant = variants[index];
      if (!variant) return;
      const price = card.querySelector('.r-metzger-selector__option-price');
      const proof = card.querySelector('.r-metzger-selector__option-proof');
      if (price) price.textContent = `Ohne Abo ${cents(comparisonPrice(data, variant))}`;
      if (proof) proof.textContent = `Spare bis zu ${wholeEuro.format(savingsAmount(data, variant))} Euro gegenüber Einzelkauf`;
    });

    const variant = selectedVariant(root, pkg);
    const plans = sortedPlans(variant);
    const intervalCards = Array.from(root.querySelectorAll('.r-metzger-selector__interval'));
    intervalCards.forEach((card, index) => {
      const plan = plans[index];
      if (!plan) return;
      const context = card.querySelector('.r-small');
      const savings = Math.max(0, comparisonPrice(data, variant) - (Number(plan.price) || 0));
      if (context) context.textContent = savings ? `Du sparst ${cents(savings)} pro Lieferung` : 'Abo-Preis pro Lieferung';
    });

    const plan = selectedPlan(root, plans);
    const summary = root.querySelector('[data-savings-summary]');
    if (summary && plan) {
      const perDelivery = Math.max(0, comparisonPrice(data, variant) - (Number(plan.price) || 0)) / 100;
      const annualSavings = perDelivery * deliveriesPerYear(plan);
      const prefix = data.savings?.annualPrefix || 'Im Jahr';
      summary.textContent = perDelivery ? `Spart ${wholeEuro.format(perDelivery)} Euro je Lieferung. ${prefix} bis zu ${wholeEuro.format(annualSavings)} Euro.` : '';
    }
  }

  function bind(root) {
    if (root.dataset.priceGuardBound === 'true') return;
    root.dataset.priceGuardBound = 'true';
    const schedule = () => {
      window.setTimeout(() => fixSelector(root), 0);
      window.setTimeout(() => fixSelector(root), 150);
      window.setTimeout(() => fixSelector(root), 600);
    };
    root.addEventListener('click', schedule, true);
    schedule();
  }

  function start() {
    document.querySelectorAll('[data-metzger-selector]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
